import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import Acl from 'vue-role-acl'
// import auth from "@/plugins/auth/authService";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    // 公共访问
    {
      path: "",
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        {
          path: '/',
          name: 'homepage',
          redirect: '/guide'
          // component: () => import('@/views/pages/homepage/index.vue'),
        },
        // {
        //   path: '/pages/login/admin',
        //   name: 'page-admin-login',
        //   component: () => import('@/views/pages/login/Login.vue'),
        // },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          async beforeEnter(to, from, next) {
            if (await store.auth.isLogin()) {
              return next({path: '/guide'})
            }
            return next()
          }
        },
        {
          path: '/pages/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          async beforeEnter(to, from, next) {
            if (!await store.auth.isLogin()) {
              return next({path: '/pages/login'})
            }
            return next()
          }
        },
      ]
    },
    // 后台页面
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      // 登录验证
      async beforeEnter(to, from, next) {
        if (!await store.auth.isLogin()) {
          return next({path: '/pages/login'})
        }
        return next()
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        // {
        //   path: '/',
        //   redirect: '/order/list',
        // },
        {
          path: '/empty',
          name: 'empty',
          component: () => import('@/views/apps/Empty.vue'),
        },
        // =============================================================================
        // Pages Routes
        // =============================================================================

        // 用户管理
        {
          path: '/user/list/admin',
          name: 'user-admin',
          component: () => import('@/views/apps/user/admin.vue'),
          meta: {
            rule: 'user_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '用户管理'},
              {title: '管理员', active: true},
            ],
            pageTitle: '管理员',
          }
        },
        {
          path: '/user/list/channel',
          name: 'user-channel',
          component: () => import('@/views/apps/user/channel.vue'),
          meta: {
            rule: 'user_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '用户管理'},
              {title: '渠道商管理', active: true},
            ],
            pageTitle: '渠道商管理',
          }
        },
        {
          path: '/user/list/user',
          name: 'user-user',
          component: () => import('@/views/apps/user/user.vue'),
          meta: {
            rule: 'user_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '用户管理'},
              {title: '普通用户', active: true},
            ],
            pageTitle: '普通用户',
          }
        },

        {
          path: '/user/create',
          name: 'user-create',
          component: () => import('@/views/apps/user/edit.vue'),
          meta: {
            rule: 'user_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '用户管理', url: '/user/list'},
              {title: '创建用户', active: true},
            ],
            pageTitle: '创建用户',
          }
        },
        {
          path: '/user/edit/:id',
          name: 'user-edit',
          component: () => import('@/views/apps/user/edit.vue'),
          meta: {
            rule: 'user_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '用户管理', url: '/user/list'},
              {title: '编辑用户', active: true},
            ],
            pageTitle: '编辑用户',
          }
        },
        // {
        //   path: '/user/admin',
        //   name: 'user-admin',
        //   component: () => import('@/views/apps/user/admin.vue'),
        //   meta: {
        //     rule: 'admin',
        //     breadcrumb: [
        //       { title: '首页', url: '/' },
        //       { title: '用户管理', url: '/user/list' },
        //       { title: '管理员列表', active: true },
        //     ],
        //     pageTitle: '管理员列表',
        //   }
        // },

        // 商品管理
        {
          path: '/product/list',
          name: 'product-list',
          component: () => import('@/views/apps/product/list.vue'),
          meta: {
            rule: 'product_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', active: true},
            ],
            pageTitle: '商品管理',
          }
        },
        {
          path: '/product/edit/:id',
          name: 'product-edit',
          component: () => import('@/views/apps/product/edit.vue'),
          meta: {
            rule: 'product_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              {title: '编辑商品', active: true},
            ],
            pageTitle: '编辑商品',
          }
        },
        {
          path: '/product/create',
          name: 'product-edit',
          component: () => import('@/views/apps/product/edit.vue'),
          meta: {
            rule: 'product_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              {title: '创建商品', active: true},
            ],
            pageTitle: '创建商品',
          }
        },
        // 批号
        {
          path: '/batchno/detail/:batchID',
          name: 'batchNo-detail',
          component: () => import('@/views/apps/batchNo/detail.vue'),
          meta: {
            rule: 'batch_view',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              {title: '溯源资料详情', active: true},
            ],
            pageTitle: '溯源资料详情',
          }
        },
        {
          path: '/batchno/:batchID/order/create',
          name: 'batchNo-order',
          component: () => import('@/views/apps/batchNo/order.vue'),
          meta: {
            rule: 'batch_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              // { title: '批号详情', getUrl: $s => {
              //   return '/batchno/detail/' + $s.product.batchno.batchID
              // } },
              {title: '创建订单', active: true},
            ],
            pageTitle: '创建订单',
          }
        },
        {
          path: '/batchno/:batchID/trace/create',
          name: 'batchNo-trace',
          component: () => import('@/views/apps/batchNo/trace.vue'),
          meta: {
            rule: 'batch_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              // { title: '批号详情', getUrl: $s => '/batchno/detail/' + $s.product.batchno.batchID },
              {title: '新建溯源', active: true},
            ],
            pageTitle: '新建溯源内容',
          }
        },
        {
          path: '/batchno/:batchID/trace/edit/:traceID',
          name: 'batchNo-trace',
          component: () => import('@/views/apps/batchNo/trace.vue'),
          meta: {
            rule: 'batch_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '商品管理', url: '/product/list'},
              // { title: '批号详情', getUrl: $s => '/batchno/detail/' + $s.product.batchno.batchID },
              {title: '新建溯源', active: true},
            ],
            pageTitle: '新建溯源内容',
          }
        },

        // 订单
        {
          path: '/order/list',
          name: 'order-list',
          component: () => import('@/views/apps/order/list.vue'),
          meta: {
            rule: 'order_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '订单管理', active: true},
            ],
            pageTitle: '订单管理',
          }
        },

        {
          path: '/order/pay/:orderid',
          name: 'order-pay',
          component: () => import('@/views/apps/batchNo/pay.vue'),
          meta: {
            rule: 'batch_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '订单管理', url: '/product/list'},
              {title: '订单支付', active: true},
            ],
            pageTitle: '订单支付',
          }
        },
        {
          path: '/order/edit/:orderid',
          name: 'order-edit',
          component: () => import('@/views/apps/order/edit.vue'),
          meta: {
            rule: 'order_admin',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '订单管理', url: '/order/list'},
              {title: '修改订单', active: true},
            ],
            pageTitle: '修改订单',
          }
        },

        // 客户管理
        {
          path: '/customer/list',
          name: 'customer-list',
          component: () => import('@/views/apps/customer/list.vue'),
          meta: {
            rule: 'customer_list',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '客户管理', active: true},
            ],
            pageTitle: '客户管理',
          }
        },
        {
          path: '/customer/edit/:id',
          name: 'customer-edit',
          component: () => import('@/views/apps/customer/edit.vue'),
          meta: {
            rule: 'customer_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '客户管理', url: '/customer/list'},
              {title: '编辑客户', active: true},
            ],
            pageTitle: '编辑客户资料',
          }
        },
        {
          path: '/customer/create',
          name: 'customer-create',
          component: () => import('@/views/apps/customer/edit.vue'),
          meta: {
            rule: 'customer_edit',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '客户管理', url: '/customer/list'},
              {title: '新建客户', active: true},
            ],
            pageTitle: '新建客户',
          }
        },

        {
          path: '/pages/ucenter',
          name: 'page-ucenter',
          component: () => import('@/views/pages/ucenter.vue'),
          meta: {
            rule: 'login'
          },
        },
        {
          path: '/pages/setting',
          name: 'page-setting',
          component: () => import('@/views/pages/user-setting/index.vue'),
          meta: {
            rule: 'login'
          },
        },

        {
          path: '/pages/price',
          name: 'page-price',
          component: () => import('@/views/pages/price.vue'),
          meta: {
            rule: 'price_admin',
            pageTitle: '价格设置',
            breadcrumb: [
              {title: '首页', url: '/'},
              {title: '价格设置', active: true},
            ],
          },
        },
      ],
    },
    // 后台的全屏页
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      async beforeEnter(to, from, next) {
        if (!await store.auth.isLogin()) {
          return next({path: '/pages/login'})
        }
        return next()
      },
      children: [
        // 引导页
        {
          path: '/guide',
          name: 'admin-guide',
          component: () => import('@/views/pages/guide.vue'),
        },

      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      component: () => import('@/views/pages/Error404.vue'),
      // redirect: '/pages/error-404'
    }
  ],
})

Vue.use(Acl, {

  ruleFail: "/pages/not-authorized",
  rules: {'*': ['public']},
  router,
  async initRule(acl) {
    await store.initRule(acl)
  }
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
